import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-e3a7f8a6")

_pushScopeId("data-v-e3a7f8a6")
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "p-d-flex p-jc-start p-ai-center" }
const _hoisted_3 = { class: "p-pb-1 p-mr-4" }
const _hoisted_4 = {
  key: 0,
  class: "p-pb-1 p-mr-4"
}
const _hoisted_5 = { class: "p-error" }
const _hoisted_6 = { class: "p-ml-auto" }
const _hoisted_7 = { class: "p-mr-1" }
const _hoisted_8 = { class: "p-d-flex p-ai-center" }
const _hoisted_9 = {
  key: 0,
  class: "p-pl-2 p-error"
}
const _hoisted_10 = {
  key: 1,
  class: "p-pl-2 p-error"
}
const _hoisted_11 = {
  key: 2,
  class: "p-pl-2"
}
const _hoisted_12 = {
  class: "pi pi-info-circle p-ml-1",
  style: {"vertical-align":"middle"}
}
const _hoisted_13 = {
  key: 3,
  class: "p-pl-2"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_DataType = _resolveComponent("DataType")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_TabMenu = _resolveComponent("TabMenu")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_ctx.listRowData.length > 0)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, _toDisplayString(_ctx.listHeader.length) + " " + _toDisplayString(_ctx.$t("upload.datasource.colums")) + " _ " + _toDisplayString(_ctx.listRowData.length) + " / " + _toDisplayString(_ctx.totalRow) + " " + _toDisplayString(_ctx.$t("upload.datasource.row")), 1),
          (_ctx.hasError)
            ? (_openBlock(), _createBlock("div", _hoisted_4, [
                _createVNode("span", _hoisted_5, _toDisplayString(_ctx.$t("datasource.error.invalid_headers")), 1)
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_6, [
            _createVNode("span", _hoisted_7, _toDisplayString(_ctx.$t("upload.datasource.label.column.selection")), 1),
            _createVNode(_component_MultiSelect, {
              modelValue: _ctx.selectedColumns,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedColumns = $event)),
              options: _ctx.listHeader,
              optionLabel: "header",
              style: {"width":"20em"}
            }, {
              value: _withId(() => [
                _createVNode("div", null, _toDisplayString(_ctx.$t("label.number.of.selected.columns", {
                  selected: _ctx.selectedColumns.length,
                  total: _ctx.listHeader.length,
                })), 1)
              ]),
              _: 1
            }, 8, ["modelValue", "options"])
          ])
        ]),
        _createVNode(_component_DataTable, {
          scrollable: true,
          scrollHeight: "400px",
          value: _ctx.listRowData,
          showGridlines: "",
          class: "p-datatable-sm"
        }, {
          default: _withId(() => [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectedColumns, (col, key) => {
              return (_openBlock(), _createBlock(_component_Column, {
                key: key,
                field: col.field,
                style: {"min-width":"200px"}
              }, {
                header: _withId(() => [
                  _createVNode("div", _hoisted_8, [
                    _createVNode(_component_DataType, {
                      dataType: col.code.type
                    }, null, 8, ["dataType"]),
                    (_ctx.checkIfStringHasSpecialChar(col.header))
                      ? _withDirectives((_openBlock(), _createBlock("div", _hoisted_9, [
                          _createTextVNode(_toDisplayString(col.header), 1)
                        ], 512)), [
                          [_directive_tooltip, _ctx.$t('upload.datasource.header.column.error')]
                        ])
                      : (_ctx.checkIfDuplicatedName(col.header))
                        ? _withDirectives((_openBlock(), _createBlock("div", _hoisted_10, [
                            _createTextVNode(_toDisplayString(col.header), 1)
                          ], 512)), [
                            [_directive_tooltip, _ctx.$t('upload.datasource.header.column.duplicate')]
                          ])
                        : (_ctx.checkIfHasIdInName(col.header))
                          ? (_openBlock(), _createBlock("div", _hoisted_11, [
                              _createTextVNode(_toDisplayString(col.header) + " ", 1),
                              _withDirectives(_createVNode("i", _hoisted_12, null, 512), [
                                [_directive_tooltip, 
                  _ctx.$t('upload.datasource.header.column.has.id', {
                    suffix: _ctx.checkIfHasIdInName(col.header),
                  })
                ]
                              ])
                            ]))
                          : (_openBlock(), _createBlock("div", _hoisted_13, _toDisplayString(col.header), 1))
                  ])
                ]),
                _: 2
              }, 1032, ["field"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["value"]),
        (_ctx.workbook)
          ? (_openBlock(), _createBlock(_component_TabMenu, {
              key: 0,
              model: _ctx.worksheetNames,
              onTabChange: _ctx.onTabChange
            }, null, 8, ["model", "onTabChange"]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
})